require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-heuristics-and-design.json") })
        }
      }, "path---blog-heuristics-and-design");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-heuristics-and-design!./.cache/json/blog-heuristics-and-design.json
// module id = 833
// module chunks = 231608221292675